import { useState, useEffect } from 'react';

// This function return the 16/9 size proportion taking in count the width of the screen
function useVideoProportionCalculator() {
  const [width, setWidth] = useState(calculateWidth());
  const [height, setHeight] = useState(calculateHeight(width));

  function calculateHeight(newWidth) {
    return newWidth * (9 / 16);
  }

  function calculateWidth() {
    const windowWitdh = window.innerWidth;
    return windowWitdh * 0.6;
  }

  const handleResize = () => {
    const newWidth = calculateWidth();

    setWidth(newWidth);
    setHeight(calculateHeight(newWidth));
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { width, height };
}

export default useVideoProportionCalculator;
